export const PlayerSignUpStep = {
  PLAYER_EMAIL_PASSWORD: "PLAYER_EMAIL_PASSWORD",
  PLAYER_PAYMENT_INFORMATION: "PLAYER_PAYMENT_INFORMATION",
  PLAYER_FINISH_SIGN_UP: "PLAYER_FINISH_SIGN_UP",
  PLAYER_PROFILE_DATA: "PLAYER_PROFILE_DATA",
  PLAYER_BUSINESS_DATA: "PLAYER_BUSINESS_DATA",
} as const;

export type PlayerSignUpStep = (typeof PlayerSignUpStep)[keyof typeof PlayerSignUpStep];

export const signUpSteps: Record<number, PlayerSignUpStep> = {
  1: PlayerSignUpStep.PLAYER_EMAIL_PASSWORD,
  2: PlayerSignUpStep.PLAYER_PAYMENT_INFORMATION,
  3: PlayerSignUpStep.PLAYER_FINISH_SIGN_UP,
  4: PlayerSignUpStep.PLAYER_PROFILE_DATA,
  5: PlayerSignUpStep.PLAYER_BUSINESS_DATA,
};
